import { render, staticRenderFns } from "./AboutUsPage.vue?vue&type=template&id=2dbbd7f8"
import script from "./AboutUsPage.vue?vue&type=script&lang=js"
export * from "./AboutUsPage.vue?vue&type=script&lang=js"
import style0 from "./AboutUsPage.vue?vue&type=style&index=0&id=2dbbd7f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports